module.exports = __webpack_public_path__ + "static/media/21ECLAC14.8ae0e32c.jpg";